// Used in login-routing.module.ts

// Angular
import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";

// Services/Types/Helpers
import { FormHelper } from "#helpers/form.helper";
// Validators
import { ProfileValidator, PwdLength } from "#validators/profile.validator";

// RXJS/Store
import * as fromStore from "#login/store";
import { Auth, UpdateProfileRequest } from "@carnegie-learning/data-access-angular-passport";
import { Store, select } from "@ngrx/store";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-login-temp-pwd",
    templateUrl: "./login-temp-pwd.component.html",
    styleUrls: ["./login-temp-pwd.component.scss"],
    standalone: false
})
export class LoginTempPwdComponent implements OnInit, OnDestroy {
    hide1 = true; // Password visibility for temp Pwd
    hide2 = true; // Password visibility for new Pwd
    hide3 = true; // Password visibility for confirm Pwd
    profileData: any;
    tempPwdShowError$?: Observable<boolean>;
    formSubmitted = false;
    tempPwdForm = this.fb.group({
        passwordGroup: this.fb.group(
            {
                password: ["", { validators: [Validators.required] }],
                newPassword: [
                    "",
                    { validators: [Validators.required, PwdLength()] },
                ],
                confirmPassword: ["", { validators: [Validators.required] }],
            },
            {
                validator: ProfileValidator.matchPassword,
            }
        ),
    });
    private ngUnsubscribe = new Subject();

    constructor(
        private auth: Auth,
        private fb: UntypedFormBuilder,
        public store: Store<fromStore.UserState>,
        public formHelper: FormHelper,
        private router: Router
    ) {}

    ngOnInit() {
        this.store
            .pipe(select(fromStore.getTempPwdDetected))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
                if (data === false) {
                    // you can only access this page when temp pwd is set
                    this.store.dispatch(
                        fromStore.userLogout({ signout: true })
                    );
                }
            });

        this.tempPwdShowError$ = this.store.pipe(
            select(fromStore.getUpdateProfileError)
        );

        this.tempPwdShowError$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((flag: any) => {
                if (flag) {
                    this.formSubmitted = false;
                }
            });

        this.store
            .pipe(select(fromStore.getUserProfile))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
                this.profileData = data;
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }

    validate(field: string, type: string) {
        return this.formHelper.Validate(this.tempPwdForm, field, type);
    }

    // password validation chip color
    chipColor(type: string) {
        if (!this.tempPwdForm.get("passwordGroup.newPassword")?.touched) {
            // initial state
            return "info";
        }

        const result = this.formHelper.Validate(
            this.tempPwdForm,
            "passwordGroup.newPassword",
            type
        );
        return result ? "info" : "primary";
    }

    markAsTouched(event: KeyboardEvent) {
        this.tempPwdForm.markAsTouched();
    }

    goBack() {
        this.store.dispatch(fromStore.userLogout({ signout: true }));
    }

    submit() {
        const payload: UpdateProfileRequest = {
            firstName: this.profileData.firstName,
            lastName: this.profileData.lastName,
            timezone: this.profileData.timezone,
            password: this.tempPwdForm.get("passwordGroup.password")?.value,
            newPassword: this.tempPwdForm.get("passwordGroup.newPassword")
                ?.value,
            confirmPassword: this.tempPwdForm.get(
                "passwordGroup.confirmPassword"
            )?.value,
        };

        this.formSubmitted = true;

        this.tempPwdForm.markAsUntouched();
        this.store.dispatch(
            fromStore.userProfileUpdateAttempt({ payload: payload })
        );
    }
}
